import { render, staticRenderFns } from "./PagedVideoSegment.vue?vue&type=template&id=7311de04&scoped=true&"
import script from "./PagedVideoSegment.vue?vue&type=script&lang=js&"
export * from "./PagedVideoSegment.vue?vue&type=script&lang=js&"
import style0 from "./PagedVideoSegment.vue?vue&type=style&index=0&id=7311de04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7311de04",
  null
  
)

export default component.exports